import rybbit from "@rybbit/js";
import React, { useContext } from "react";
import { useRecoilValue } from "recoil";
import { LocaleAtom } from "../../state/localeAtom";

type TourStepContentProps = {
	description: React.ReactNode | (() => React.ReactNode);
};

export const QpTourContext = React.createContext<{
	isAuthenticated: boolean;
}>({
	isAuthenticated: false,
});

const TourStepContent = ({ description }: TourStepContentProps) => {
	const { isAuthenticated } = useContext(QpTourContext);
	useRecoilValue(LocaleAtom);
	const content = typeof description === "function" ? description() : description;
	return (
		<div>
			<div
				style={{
					display: isAuthenticated ? "none" : "flex",
					justifyContent: "flex-start",
				}}
			>
				<button
					type="button"
					onClick={() => {
						try {
							rybbit.event("tour_signup_click", {});
						} catch {
							// analytics must never block the signup navigation
						}
						window.location.href = "/signup";
					}}
					style={{
						background: "none",
						border: "none",
						padding: 0,
						marginBottom: "15px",
						color: "grey",
						textDecoration: "underline",
						cursor: "pointer",
						fontSize: "inherit",
					}}
				>
					Sign Up Here
				</button>
			</div>
			<div>{content}</div>
		</div>
	);
};

export default TourStepContent;
